import { styled, Box, Typography, Button } from "@mui/material";
import { colors } from "../../../theme/colors";

export const ModalContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
});

export const ModalTitle = styled(Typography)({
  fontSize: "26px",
  fontWeight: 600,
  fontFamily: "Sora",
  color: colors.text.primary,
  textAlign: "center",
});

export const ModalSubtitle = styled(Typography)({
  fontSize: "18px",
  fontWeight: 600,
  fontFamily: "Sora",
  color: colors.text.secondary,
  textAlign: "center",
  marginTop: "12px",
});

export const SelectContainer = styled(Box)({
  width: "100%",
  marginTop: "32px",
});

export const ButtonsContainer = styled(Box)({
  display: "flex",
  gap: "16px",
  justifyContent: "center",
  marginTop: "32px",
});

export const CancelButton = styled(Button)({
  minWidth: "140px",
});

export const AssignButton = styled(Button)({
  minWidth: "140px",
  backgroundColor: colors.amber.main,
  "&:hover": {
    backgroundColor: colors.amber.dark,
  },
});
